import { getIsApiPending } from '../../../selectors/travelKe/travelAgentModal';
import { apiTransitionAgents, setAllAgentsValue } from '../../../actions/travelKe/motorAgentModal';
import { getAccessToken } from '../../../selectors/travelKe/payments';
import { getIntermediaryType } from '../../../selectors/travelKe/travelAgentModal';
import axios from 'axios';

export const getAgentsService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionAgents.pending());
            try {
                const resp = await getAgents(store.getState());

                store.dispatch(setAllAgentsValue(resp.data.agents));
                store.dispatch(apiTransitionAgents.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionAgents.failure());
            }
        }
    })();
    return next(action);
};

const getAgents = async (state) => {
    const loginData = getAccessToken(state);
    const intermediaryType = getIntermediaryType(state);

    try {
        const url = '/om-api/travel-ke/agents';
        return await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                type: intermediaryType.value || 'AGENTS',
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
